export interface LineItem {
  name: string;
  quantity: number;
  unit_price: number;
  total: number;
  category: ExpenseCategory;
}

export type ExpenseCategory =
  | 'beans'
  | 'milk'
  | 'syrups'
  | 'beverages'
  | 'cups'
  | 'ice'
  | 'towels'
  | 'equipment'
  | 'cleaning'
  | 'food'
  | 'other';

export type ExpenseStatus = 'pending' | 'reimbursed' | 'donation';

export interface Expense {
  id: string;
  created_at: string;
  user_id: string;
  transaction_date: string;
  store_name: string | null;
  items: LineItem[];
  subtotal: number;
  tax: number;
  discount?: number;
  total: number;
  status: ExpenseStatus;
  notes: string | null;
  receipt_url: string | null;
  last_updated_at?: string;
  updated_by?: string;
}

export interface ExpenseFormData {
  id?: string;
  transaction_date: string;
  store_name: string;
  items: LineItem[];
  subtotal: number;
  tax: number;
  discount?: number;
  total: number;
  status?: ExpenseStatus;
  notes?: string;
}

export interface Profile {
  id: string;
  display_name: string | null;
  email: string | null;
  role: string;
  created_at: string;
}

export const CATEGORY_LABELS: Record<ExpenseCategory, string> = {
  beans: 'Coffee Beans',
  milk: 'Milk & Cream',
  syrups: 'Syrups & Flavors',
  beverages: 'Beverages & Ingredients',
  cups: 'Cups & Lids',
  ice: 'Ice',
  towels: 'Towels & Napkins',
  equipment: 'Equipment',
  cleaning: 'Cleaning Supplies',
  food: 'Food & Pastries',
  other: 'Other',
};

export const CATEGORY_ICONS: Record<ExpenseCategory, string> = {
  beans: '☕',
  milk: '🥛',
  syrups: '🍯',
  beverages: '🧃',
  cups: '🥤',
  ice: '🧊',
  towels: '🧻',
  equipment: '⚙️',
  cleaning: '🧹',
  food: '🥐',
  other: '📦',
};

export const STATUS_LABELS: Record<ExpenseStatus, string> = {
  pending: 'Pending',
  reimbursed: 'Reimbursed',
  donation: 'Donation',
};
